import { ErrorBoundary } from '@sentry/react';
import { TrainingContextProvider } from '@sparx/teacher-training';
import { schoolStaffClient, trainingProgressClient } from 'api';
import { useClientEvent } from 'components/client-events/client-event-provider';
import { queryClient } from 'queries/client';
import { useUser } from 'queries/session';
import { PropsWithChildren } from 'react';

import { TRAINING_MODULES } from './module-specs';

export const TrainingContext = ({ children }: PropsWithChildren) => {
  const user = useUser();
  const { sendEvent } = useClientEvent();

  return (
    <ErrorBoundary>
      <TrainingContextProvider
        value={{
          schoolID: user?.schoolId || '',
          videoAssetDirURL: 'https://static.sparxhomework.uk/assets/reader/training/',
          moduleSpecs: TRAINING_MODULES,
          queryClient: queryClient,
          trainingProgressClient: trainingProgressClient,
          staffClient: schoolStaffClient,
          sendClientEvent: sendEvent,
        }}
      >
        {children}
      </TrainingContextProvider>
    </ErrorBoundary>
  );
};
